
(function () {
  'use strict';

  var Z = 2147483001; /* one above the PhotoSwipe override */
  var overlay = null;
  var stage = null;
  var lastFocus = null;

  function build() {
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'pvl';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;
    overlay.style.zIndex = String(Z);

    var backdrop = document.createElement('div');
    backdrop.className = 'pvl__backdrop';

    stage = document.createElement('div');
    stage.className = 'pvl__stage';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'pvl__close';
    close.setAttribute('aria-label', 'Close video');

    overlay.appendChild(backdrop);
    overlay.appendChild(stage);
    overlay.appendChild(close);
    document.body.appendChild(overlay);

    close.addEventListener('click', hide);

    /* Outside click. Guarded by pointer travel so a drag that ends outside
       the player is not treated as a dismissing tap. */
    var start = null;
    overlay.addEventListener('pointerdown', function (e) {
      start = { x: e.clientX, y: e.clientY };
    });
    overlay.addEventListener('pointerup', function (e) {
      var s = start;
      start = null;
      if (s && Math.hypot(e.clientX - s.x, e.clientY - s.y) > 10) return;
      if (e.target.closest('.pvl__stage, .pvl__close')) return;
      hide();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) hide();
    });

    return overlay;
  }

  function show(templateEl, opener) {
    build();
    lastFocus = opener || null;

    /* Fresh clone each time: reusing the node would resume a YouTube iframe
       at its old position and keep the previous video's state. */
    stage.innerHTML = '';
    stage.appendChild(templateEl.content.cloneNode(true));

    var frame = stage.querySelector('iframe, video');
    if (frame) {
      frame.setAttribute('width', '100%');
      frame.setAttribute('height', '100%');
      if (frame.tagName === 'VIDEO') {
        frame.setAttribute('controls', 'controls');
        var p = frame.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    overlay.hidden = false;
    document.body.classList.add('pvl-open');
    var btn = overlay.querySelector('.pvl__close');
    if (btn) btn.focus();
  }

  function hide() {
    if (!overlay || overlay.hidden) return;
    /* Emptying the stage tears down the iframe, which is the only reliable
       way to stop YouTube audio. */
    stage.innerHTML = '';
    overlay.hidden = true;
    document.body.classList.remove('pvl-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  /* Capture phase: DeferredMedia in global.js binds its own click on the
     poster and would load the player inline before we ever saw the event. */
  document.addEventListener(
    'click',
    function (e) {
      var poster = e.target.closest('.deferred-media__poster');
      if (!poster) return;

      var host = poster.closest('deferred-media');
      if (!host) return; /* product-model keeps its own AR viewer */
      if (!host.closest('.product_main_image, .product__media-item')) return;

      var tpl = host.querySelector('template');
      if (!tpl) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var slide = host.closest('[data-pswp-idx]');
      if (slide && typeof window.pocoOpenGallery === 'function') {
        window.pocoOpenGallery(parseInt(slide.getAttribute('data-pswp-idx'), 10));
        return;
      }
      show(tpl, poster);
    },
    true
  );

  window.pocoVideoLightbox = { show: show, hide: hide };
})();
